import acceptOrder from './triggers/acceptOrder'
import finishDelivery from './triggers/finishDelivery'
import launchWithdrawal from './triggers/launchWithdrawal'
import saveNextPointReached from './triggers/saveNextPointReached'
import setRiderAvailability from './triggers/setRiderAvailability'
import saveKyc from './triggers/saveKyc'
import buyProduct from './triggers/buyProduct'
import payProductPurchase from './triggers/payProductPurchase'
import updateLocation from './triggers/updateLocation'
import updateKyc from './triggers/updateKyc'
import submitKyc from './triggers/submitKyc'
import confirmProductBuy from './triggers/confirmProductBuy'
import markNotificationRead from './triggers/markNotificationRead'
import markAllNotificationsRead from './triggers/markAllNotificationsRead'
import createWithdrawalAccount from './triggers/createWithdrawalAccount'
import updateWithdrawalAccount from './triggers/updateWithdrawalAccount'

const data = {
  acceptOrder,
  saveNextPointReached,
  finishDelivery,
  launchWithdrawal,
  createWithdrawalAccount,
  updateWithdrawalAccount,
  setRiderAvailability,
  saveKyc,
  buyProduct,
  payProductPurchase,
  updateLocation,
  updateKyc,
  submitKyc,
  confirmProductBuy,
  markNotificationRead,
  markAllNotificationsRead,
}

const actionSerializers = {}
const actionEndpoints = {}

Object.keys(data).forEach(key => {
  const item = data[key]

  const endpoint = {
    POST:
      item.postUrl ||
      function () {
        return ''
      },
    PUT:
      item.putUrl ||
      function () {
        return ''
      },
    GET:
      item.getUrl ||
      function () {
        return ''
      },
    PATCH:
      item.patchUrl ||
      function () {
        return ''
      },
    DELETE:
      item.deleteUrl ||
      function () {
        return ''
      },
  }
  actionEndpoints[key] = endpoint

  class Serializer {
    get type() {
      return key
    }
    deserialize(...args) {
      return item.parse(...args)
    }
    serialize(...args) {
      return item.format(...args)
    }
  }
  actionSerializers[key] = Serializer
})

export { actionSerializers, actionEndpoints }
